import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import PublicLayout from "@/components/PublicLayout";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LogIn } from "lucide-react";

export default function Login() {
  const { t } = useTranslation();
  const { login, loading } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });

  const submit = async (e) => {
    e.preventDefault();
    try {
      const u = await login(form.email, form.password);
      toast.success(t("login.welcome", { name: u.name }));
      nav(u.role === "admin" ? "/admin" : "/associat");
    } catch (err) {
      toast.error(err.response?.data?.detail || t("login.err_auth"));
    }
  };

  return (
    <PublicLayout>
      <div className="max-w-md mx-auto px-6 py-20">
        <Card className="rounded-3xl border-2 shadow-xl shadow-primary/5">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-primary text-primary-foreground flex items-center justify-center mb-4">
                <LogIn className="w-6 h-6" />
              </div>
              <h1 className="font-heading font-bold text-2xl">{t("login.title")}</h1>
              <p className="text-sm text-muted-foreground mt-1">{t("login.subtitle")}</p>
            </div>
            <form onSubmit={submit} className="space-y-4" data-testid="login-form">
              <div>
                <Label>{t("login.email")}</Label>
                <Input type="email" className="mt-2 rounded-xl" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="login-email-input" />
              </div>
              <div>
                <Label>{t("login.password")}</Label>
                <Input type="password" className="mt-2 rounded-xl" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="login-password-input" />
              </div>
              <Button type="submit" disabled={loading} size="lg" className="w-full rounded-full h-12" data-testid="login-submit-btn">
                {loading ? t("login.entering") : t("login.submit")}
              </Button>
              <div className="text-center pt-2">
                <a href="/oblidat" className="text-sm text-muted-foreground hover:text-primary underline-offset-4 hover:underline" data-testid="login-forgot-link">
                  Has oblidat la contrasenya?
                </a>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </PublicLayout>
  );
}
